import { render, staticRenderFns } from "./stopped-list.component.vue?vue&type=template&id=bb1c9844&scoped=true"
import script from "./stopped-list.component.vue?vue&type=script&lang=js"
export * from "./stopped-list.component.vue?vue&type=script&lang=js"
import style0 from "./stopped-list.component.vue?vue&type=style&index=0&id=bb1c9844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1c9844",
  null
  
)

export default component.exports